import { spacing } from '../../../shared/theme/spacing'
import { typography } from '../../../shared/theme/typography'
import { ticketColors, ticketFonts } from '../../../shared/theme/ticketColors';

export const posCheckoutFiscalStyleDefs = {
  /** Caja `.field-toggle` del proto — control con borde firme, radius chico. */
  checkoutFiscalSwitchRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing.md,
    paddingVertical: 10,
    paddingHorizontal: spacing.md,
    borderWidth: 1,
    borderColor: ticketColors.rule,
    borderRadius: 10,
    backgroundColor: ticketColors.paper,
  },

  checkoutFiscalSwitchRowActive: {
    borderColor: ticketColors.gold,
    backgroundColor: ticketColors.brandSoft,
  },

  checkoutFiscalSwitchLeading: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
    minWidth: 0,
  },

  checkoutFiscalSwitchText: {
    flex: 1,
    gap: 2,
    minWidth: 0,
  },

  checkoutFiscalSwitchTitle: {
    fontSize: 13,
    fontWeight: '600',
    color: ticketColors.ink,
    fontFamily: ticketFonts.sans,
  },

  checkoutFiscalSwitchHint: {
    ...typography.caption,
    fontSize: 11,
    lineHeight: 15,
    color: ticketColors.ink3,
    fontFamily: ticketFonts.sans,
  },

  checkoutNonFiscalBodyInline: {
    ...typography.caption,
    fontSize: 11,
    lineHeight: 14,
    color: ticketColors.ink2,
    flex: 1,
    minWidth: 0,
    fontFamily: ticketFonts.sans,
  },

  checkoutFiscalBuyerBlock: {
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: spacing.sm,
  },

  checkoutFiscalBuyerCfRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  fiscalFieldLabel: {
    ...typography.caption,
    color: ticketColors.ink2,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    fontFamily: ticketFonts.sans,
  },

  checkoutNonFiscalBody: {
    ...typography.caption,
    fontSize: 11,
    lineHeight: 14,
    color: ticketColors.ink2,
    marginTop: 4,
    fontFamily: ticketFonts.sans,
  },

  checkoutFiscalInvoiceTypeRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing.sm,
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.md,
    borderRadius: 14,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper2,
  },

  checkoutFiscalInvoiceTypeLabel: {
    ...typography.caption,
    fontSize: 11,
    fontWeight: '700',
    color: ticketColors.ink3,
    textTransform: 'uppercase',
    letterSpacing: 0.4,
    fontFamily: ticketFonts.sans,
  },

  checkoutFiscalInvoiceTypeValue: {
    ...typography.body,
    fontSize: 15,
    fontWeight: '700',
    color: ticketColors.ink,
    fontFamily: ticketFonts.sans,
  },
} as const;
